































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import BaseSelectOption from '@shared/components/@atoms/BaseSelectOption/BaseSelectOption.vue';
import BaseSelect from '@shared/components/@molecules/BaseSelect/BaseSelect.vue';
import responsiveMixin from '@shared/ui/utilities/mixins/responsiveMixin';

import { IContactFormField, IContactFormOption } from '../types';

export default defineComponent({
  name: 'ContactFormEnquiryField',
  components: { BaseSelect, BaseSelectOption },
  mixins: [responsiveMixin],
  props: {
    field: {
      type: Object as PropType<IContactFormField | IContactFormOption>,
      required: true,
    },
    reset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const children = null as IContactFormField | IContactFormOption | null;
    return {
      children,
      selectionValue: '',
      shouldResetChildren: false,
    };
  },
  computed: {
    hasLongText(): boolean {
      const charLimit = this.isMobile ? 30 : 60;
      return !!(
        this.selectionValue &&
        this.field.dropdownOptions[this.selectionValue as unknown as number].label.length >
          charLimit
      );
    },
  },
  watch: {
    selectionValue: function (newValue, oldValue) {
      if (oldValue !== '' && newValue !== '') {
        this.shouldResetChildren = true;
      }
    },
    reset: function (newValue) {
      if (newValue) {
        this.selectionValue = '';
        this.children = null;
        this.shouldResetChildren = false;
        this.$emit('reset-contact-form');
        this.$emit('reset-complete');
      }
    },
  },
  methods: {
    resetComplete() {
      this.shouldResetChildren = false;
    },
    onSelect() {
      const inputField = this.field;
      inputField.value = this.field.dropdownOptions[this.selectionValue as unknown as number].label;
      inputField.mappedLabel = this.field.label;
      this.$emit('updated-input', inputField);

      const nestedList = this.field.dropdownOptions[this.selectionValue as unknown as number];
      if (nestedList && nestedList.dropdownOptions.length) {
        // if nested list
        this.children = nestedList;
      } else {
        // if leaf node
        const fieldToDisplayCheck =
          this.field.dropdownOptions[this.selectionValue as unknown as number].fieldsToDisplay;
        const fieldsToDisplay = fieldToDisplayCheck.fields;
        this.$emit('display-fields', fieldsToDisplay);
        this.$emit('enable-other-fields', true);
        this.$emit('reset-contact-form-partial');
      }
    },
  },
});
